// extracted by mini-css-extract-plugin
export default {"image":"TourGuideButton-module__image__t2e03"};